import PatientDocument from './PatientDocument.view';
import withNavBar from 'src/hocs/withNavBar.hoc';
import withHelmet from 'src/hocs/withHelmet';
import { compose } from 'ramda';
import withProps from 'src/hocs/withProps';
import { withCookies } from 'react-cookie';
import { t } from 'src/i18n';

const enhance = compose(
  withProps({ title: t('general.title.patientDocuments') }),
  withHelmet,
  withCookies,
  withNavBar
);

export default enhance(PatientDocument);
